import { useEffect } from "react";

import { useEventCallback } from "@alaffia-technology-solutions/hooks";

import type { PDFViewerEvents } from "./providers/state/types";

import { usePDFStore } from "./providers";

export function usePDFViewerEvent<T extends unknown[]>(
  eventName: PDFViewerEvents[keyof PDFViewerEvents] | null | undefined,
  listener: (...args: T) => void,
) {
  const { data: pdfViewerCtrl } = usePDFStore((state) => ({
    pdfViewer: state.pdfViewer,
  }));
  const pdfViewer = pdfViewerCtrl?.pdfViewer ?? null;
  const listenerCallback = useEventCallback(listener);

  useEffect(() => {
    if (!pdfViewer || !eventName) {
      return;
    }
    const eventEmitter = pdfViewer.getEventEmitter();

    eventEmitter.on(eventName, listenerCallback);

    return () => {
      eventEmitter.off(eventName, listenerCallback);
    };
  }, [eventName, listenerCallback, pdfViewer]);
}
